import { getSessionStore } from '../../../../store/createStore';
export const scanBarcode = ({ callback }) => {
    window.getData  = function(data){
        function isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }
        let parseData = isJson(data) ? JSON.parse(data) : data;
        let barcode = window.webkit ? (parseData?.code || parseData) : parseData.universal;
        console.log(barcode)
        callback(barcode);
    }
    alert("testing w.webkit: "+window?.webkit)
    alert("testing w.web.mess "+window?.webkit?.messageHandlers);
    if (window.JdLiteInterface) {
        window.JdLiteInterface.scanBarCode(JSON.stringify({fn: "getData"}));
    }else if(window.webkit){
        var appjson = JSON.stringify({type: 'barcode', fn: 'getData'});
        window.webkit.messageHandlers.callbackHandler.postMessage(appjson);
    }
};

const getUplaodObject = (strType, index, type, imgUploadUrl) => {
    let supplierId = getSessionStore().supplierId;
    if(!supplierId && typeof Manager != 'undefined'){
        supplierId = Manager.CurrentUser.getSupplierId();
    }   
    const url = imgUploadUrl && imgUploadUrl.length > 10 ? imgUploadUrl : "/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId="+supplierId;
    let data = {
        uploadSize: "10",
        ajaxUrl: location.protocol + "//" + location.host + url,
        fileType: "jpeg,jpg,png",
        fieldName: "uploadedImageFile",
        strType: strType,
        index: index,
        type: type
    }
    return data;
};

const imageOptions = (strType, index, type, imgUploadUrl, callback) => {
    if (window.jdInterface) {
        let data = getUplaodObject(strType, index, type, imgUploadUrl);
        window.jdInterface.uploadImage(JSON.stringify(data));
        window.jdInterface.appImageSuccess = function (value) {
            callback(value);
        }
    }
};

export const openCamera = ({ index, imgUploadUrl, callback }) => {
    imageOptions("open", index, "CAMERA", imgUploadUrl, callback);
};

export const openGallery = ({ index, imgUploadUrl, callback }) => {
    imageOptions("changeImage", index, "GALLERY", imgUploadUrl, callback);
};

const generateCode = (outletDetails, supid) => {
    let randomStr = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
    let sup64 = btoa(supid);
    let stId64 = btoa(outletDetails.results.storeid);
    let random64 = btoa(randomStr);
    let secData = random64 + "#" + sup64 + "#" + stId64 + "#" + sup64 + "#" + random64;
    return btoa(secData);
};

const getFileUploadObject = (secData) => {
    let object = {
        "uploadSize": "5",
        "ajaxUrl": location.protocol + "//" + location.host + "/marketplace/common/php/file.service?_=" + secData,
        "fileType": "jpg,jpeg,png,pdf,doc,docx,ppt,pptx,pps,ppsx,xls,xlsx,odt,xls,xlsx,zip,rar",
        "fieldName": "file",
        "strType": 'file',
        "mimeTypes": '',
        "showProgressBar": true,
    }
    return object;
};

export const fileManager = ({ outletDetails, supid, callback }) => {
    let object = getFileUploadObject(generateCode(outletDetails, supid));
    object.mimeTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.ms-powerpoint",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.oasis.opendocument.text",
        "application/zip",
        "application/x-rar-compressed",
        "image/*",
        "text/*"
    ];

    if (window.jdInterface) {
        window.jdInterface.openFileChooser(JSON.stringify(object));
        window.jdInterface.appImageSuccess = function (value) {
            callback(value);
        }
    }
};

export const checkAtleastOneThirdLvlCheckBox = (inputArr, cb) => {
    let isErr = false;
    const isMainSelected = inputArr.filter(mainopt => {return mainopt.value==true})
    if (isMainSelected.length) {
        isMainSelected.map(item => {
            if (!isErr && item.value) {
                if (item.subnames?.length) {
                    const subnameWithTrueValue = item.subnames.some(subname => subname.value === true);
                    if (!subnameWithTrueValue) {
                        isErr = true;
                    }
                }
            }
        })
    } else {
        isErr = true;
    }
    cb(isErr);
}